import React from 'react';
import { Button } from './ui/Button';
import { services } from '../data/services';
export function Services() {
  return <section id="services" aria-label="Services" className="w-full" data-id="element-197" data-mp="1hwxmikg9gsl9">
      {services.map((service, index) => <article key={service.title} className="sticky top-0 w-full px-5 py-16 lg:px-8 lg:py-24" style={{
      backgroundColor: service.background,
      color: service.text,
      zIndex: index + 1
    }} data-id="element-198" data-mp="1dshh0kak7n6k" data-mpi={index}>
          <div className="mx-auto flex w-full max-w-shell flex-col items-center gap-10 lg:flex-row lg:gap-[118px]" data-id="element-199" data-mp="z43gwh4j2ctp">
            <div className="flex w-full max-w-[501px] flex-col gap-8" data-id="element-200" data-mp="u6uto24ivill">
              <h2 className="text-3xl font-bold tracking-[0.01em] lg:text-5xl" data-id="element-201" data-mp="q59ci4kygi5l">
                {service.title}
              </h2>
              <p className="text-lg leading-relaxed lg:text-xl" data-id="element-202" data-mp="l4u1vks25orb">
                {service.description}
              </p>
              <div data-id="element-203" data-mp="g8damhpkaua0">
                <Button to="/#contact" variant="light" style={{
              backgroundColor: service.buttonBg,
              color: service.buttonText,
              borderColor: service.buttonBg
            }} data-id="element-204" data-mp="36chgbxha4zue">
                  {service.cta}
                </Button>
              </div>
            </div>

            <div className="w-full max-w-[412px] overflow-hidden rounded-2xl bg-[#F8F8F8]" data-id="element-205" data-mp="3q0qaue6aphx2">
              <img src={service.image} alt={service.alt} loading="lazy" className="h-full w-full object-cover" data-id="element-206" data-mp="3u220ukt3055s" />
            </div>
          </div>
        </article>)}
    </section>;
}